(function () {
  async function productVariant() {
    var settings = window.__HBP_SHOPIFY__ || {};

    if (settings.variantId) return Number(settings.variantId);
    if (!settings.productUrl) return null;

    var response = await fetch(settings.productUrl + '.js', {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return null;

    var product = await response.json();
    var variants = product.variants || [];
    var variant = variants.find(function (item) {
      return item.available;
    }) || variants[0];

    return variant ? Number(variant.id) : null;
  }

  async function addJournal() {
    var settings = window.__HBP_SHOPIFY__ || {};
    var variantId = await productVariant();

    if (!variantId) {
      window.location.assign(
        settings.productUrl || '/products/the-hoopers-blueprint-the-basketball-journal'
      );
      return false;
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    });

    if (!response.ok) {
      window.location.assign(
        settings.productUrl || '/products/the-hoopers-blueprint-the-basketball-journal'
      );
      return false;
    }

    return true;
  }

  async function checkout() {
    var cartResponse = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    var cart = await cartResponse.json();

    if (cart.item_count === 0) {
      var added = await addJournal();
      if (!added) return;
    }

    window.location.assign('/checkout');
  }

  document.addEventListener('click', async function (event) {
    var target = event.target.closest('button, a');
    if (!target) return;

    var label = (target.textContent || '').trim().replace(/\s+/g, ' ');
    var shopButton = label === 'SHOP';
    var checkoutButton =
      target.classList.contains('checkout-button') ||
      label.indexOf('SECURE CHECKOUT') !== -1;

    if (!shopButton && !checkoutButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    target.disabled = true;
    target.setAttribute('aria-busy', 'true');

    try {
      if (shopButton) {
        var added = await addJournal();
        if (added) window.location.assign('/checkout');
      } else {
        await checkout();
      }
    } catch (error) {
      console.error('Hoopers Blueprint checkout error:', error);
      var settings = window.__HBP_SHOPIFY__ || {};
      window.location.assign(
        settings.productUrl || '/products/the-hoopers-blueprint-the-basketball-journal'
      );
    } finally {
      target.disabled = false;
      target.removeAttribute('aria-busy');
    }
  }, true);
})();
